import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Flex,
  Text,
  VStack,
  Avatar,
  HStack,
  Divider,
  Heading,
  Image,
  useDisclosure,
  Spinner,
  Wrap,
  WrapItem,
  Badge,
  Tooltip,
} from '@chakra-ui/react';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import IsDesktop from '../../utils/IsDesktop';
import BrandButton from '../brandButton/BrandButton';
import { useData } from '../../data';
import ppt from '../../public/icons/ppt.svg';
import mp4 from '../../public/icons/mp4.svg';
import PlayVideo from './PlayVideo';
import ViewPitchDeck from './ViewPitchDeck';
import ConnectionButton from '../connectionButton/ConnectionButton';
import founder_cover_photo from '../../public/images/Founders.png';
import ConvertVideoLinkToEmbedLink from '../../utils/ConvertVideoLinkToEmbedLink';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { CustomToast } from '../toast/CustomToast';
import { mutateFunction, useMutation } from '../../libs/apis';
import { useDispatch, useSelector } from 'react-redux';
import { StarIcon } from '@chakra-ui/icons';
import moment from 'moment';
import { isValidURL } from '../../utils/IsValidUrl';
import ExpertBookingCalendar from '../experts/ExpertBookingCalendar';
import FoundersBookingCalendar from './FoundersBookingCalendar';
import { useNavigate } from 'react-router-dom';
import client from '../../libs/client';
import { setCurrentDealFlow } from '../../redux-toolkit/reducers/dealFlowSlice';
import UserService from '../../utils/UserService';
import { BASE_URL } from '../../helpers/constant';
import ShareContentModal from '../modal/ShareContentModal';
import { FaShareAlt, FaFlag } from 'react-icons/fa';
import UserReportModal from '../modal/ReportUserModal';
import UpgradeBanner from '../investors/UpgradeBanner';
import LockedField from '../LockedField';
import PitchDeckViewer from './PitchDeckViewer';

const ViewFounderDetails = ({
  founder,
  onToggle,
  companyId = null,
  isPublic = false,
  source = null,
  restrictView = false,
}) => {
  const accountType = useSelector(
    (state) => state?.user?.userInfo?.userTypeTitle,
  );
  const loggedInUser = useSelector((state) => state?.user?.userInfo);
  const loggedInUserSubscription = useSelector(
    (state) => state?.user?.userSubscriptionInfo,
  );
  const loggedInUserType = loggedInUser?.userTypeTitle || '';

  // Check if user is a free founder
  const getPlanTier = (planName) => {
    if (!planName) return 0;
    const planNameLower = planName.toLowerCase();
    if (planNameLower.includes('pro')) return 2;
    if (planNameLower.includes('starter')) return 1;
    return 0; // Free
  };

  const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

  const currentPlanName = loggedInUserSubscription?.subscription_plan?.name;
  const currentPlanTier = getPlanTier(currentPlanName);
  const isFreeInvestor = loggedInUserType === 'investor' && currentPlanTier === 0;
  const [pdfBlob, setPdfBlob] = useState(null);


  const isDesktop = IsDesktop();
  const { mutate, isLoading: mutateIsLoading } = useMutation(mutateFunction);

  const { data, refetch } = useData(
    `${isPublic ? 'public/users' : 'users'}/${founder}`,
    1000 * 60 * 5,
    {
      'X-C-ID': companyId,
    },
  );
  const [userData, setUserData] = useState(null);
  const [deals, setDeals] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const { addToast } = CustomToast();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { isOpen: videoIsOpen, onToggle: onToggleVideoIsOpen } =
    useDisclosure();
  const { isOpen: viewPitchDeckIsOpen, onToggle: onTogglePitchDeck } =
    useDisclosure();
  const loggedInUserId = useSelector((state) => state?.user?.userInfo?.id);
  const [count, setCount] = useState(0);
  const intervalId = useRef(null);
  const [relatedBookings, setRelatedBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDeck, setIsLoadingDeck] = useState(false);
  const companyStatus = userData?.company?.status || companyData?.status;
  const isDealReady = companyStatus == 'live';
  const isInvestorView = accountType == 'investor';
  const isFounderSelfView =
    accountType == 'founder' && loggedInUserId == founder;

  const getDealReadinessTooltip = () => {
    if (!companyStatus) return '';

    if (isInvestorView) {
      return isDealReady
        ? 'This startup has completed all required information and meets the platform deal readiness criteria.'
        : 'This startup is still completing required information to become deal ready.';
    }

    if (isFounderSelfView) {
      return isDealReady
        ? 'Your profile meets all deal readiness criteria and is visible to investors.'
        : 'Complete the remaining requirements to become deal ready.';
    }

    return '';
  };


  useEffect(() => {
    setIsLoadingDeck(true);

    const fetchDeck = async () => {
      console.log("Fetching pitch deck for founder:", founder);

      client()
      .get(`${BASE_URL}users/pitch-deck/${founder}`, {
        headers: { 'X-C-ID': companyId,  },
        responseType: 'blob', // Important for handling binary data
      })
      .then((res) => {
        console.log("blob incomging=====", res)
        const blob =  res.data;
        if (blob) {
          console.log("blobgot =====" , blob)
          setPdfBlob(URL.createObjectURL(blob));
        }else{
          console.log("blob not got =====")

        }
        setIsLoadingDeck(false);
      })
      .catch((e) => {
        console.error("Error fetching pitch deck:", e);
        setIsLoadingDeck(false);
      });
      
    };

    fetchDeck();
  }, []);


  const {
    isOpen: createShareContentIsOpen,
    onClose: onCloseShareContent,
    onOpen: onOpenShareContent,
  } = useDisclosure();
  const {
    isOpen: reportUserIsOpen,
    onClose: onCloseReportUser,
    onOpen: onOpenReportUser,
  } = useDisclosure();
  const dispatch = useDispatch();

  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');

  const showPitchDeck = () => {
    onTogglePitchDeck();
  };
  const showVideo = () => {
    onToggleVideoIsOpen();
  };

  const acceptRequest = () => {
    mutate(
      {
        key: `users/${loggedInUserId}/connections/${userData?.connection?.connection_id || userData?.connection?.id}`,
        method: 'put',
      },
      {
        onSuccess(res) {
          addToast(res);
          setSearchParams({
            userid: founder,
            usertype: 1,
          });
          refetch();
        },
      },
    );
  };

  const declineRequest = () => {
    mutate(
      {
        key: `users/${loggedInUserId}/declineConnections/${userData?.connection?.connection_id || userData?.connection?.id}`,
        method: 'put',
      },
      {
        onSuccess(res) {
          addToast(res);
          setSearchParams({
            userid: founder,
            usertype: 1,
          });
          refetch();
        },
      },
    );
  };

  const goToDeal = (id) => {
    setIsLoading(true);
    client()
      .get(`${BASE_URL}deal-flow/${id}`)
      .then((res) => {
        const deal = res.data?.data?.deal;
        if (deal) {
          dispatch(setCurrentDealFlow(deal));
          UserService.setCurrentDealFlow(deal);
          if (deal.status === 'closed') {
            navigate('/view-close-deal-flow');
          } else if (deal.status === 'signed') {
            navigate('/view-post-agreement-stage');
          } else {
            navigate('/view-term-sheet');
          }
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const refetchBookingsData = (id) => {
    setIsLoading(true);
    client()
      .get(`${BASE_URL}users/bookings/all`)
      .then((res) => {
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  function resetTimeout() {
    if (intervalId.current) {
      clearTimeout(intervalId.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    intervalId.current = setTimeout(() => {
      setCount((prev) =>
        prev === companyData?.additional_images?.length - 1 ? 0 : prev + 1,
      );
    }, 3000);

    return () => {
      resetTimeout();
    };
  }, [count, companyData?.additional_images?.length]);

  useEffect(() => {
    if (data?.data) {
      setUserData(data.data.user);
      setCompanyData(data.data.company);
      setRelatedBookings(data?.data?.user?.bookings || []);

      const _message = `Hi! Check out ${data.data.user.first_name} ${data.data.user.last_name} ${!data.data.user.first_name && !data.data.user.last_name ? `this user's` : ''} profile on SeedAFounder`;
      const _link = `${process.env.REACT_APP_FRONTEND_URL}public/profile?userid=${founder}&usertype=1${companyId ? `&cid=${companyId}` : ''}`;
      setMessage(_message);
      setLink(_link);
      if (accountType === 'investor') {
        setDeals(
          data.data.user.deals.filter((item) =>
            companyId ? item.company_id == companyId : true,
          ),
        );
      }
    }
  }, [data]);

  useEffect(() => {
    if (userData) {
      if (location?.search?.includes('status=accept')) {
        acceptRequest();
      }
      if (location?.search?.includes('status=decline')) {
        declineRequest();
      }
    }
  }, [userData, location?.search]);

  const handlePublicButtonClick = () => {
    const userId = searchParams.get('userid');
    const userType = searchParams.get('usertype');
    const redirectPath = `view-user?userid=${userId}&usertype=${userType}`;

    sessionStorage.setItem('_redirectPath', redirectPath);
    navigate('/login', { replace: true });
  };

  // Handle upgrade modal opening
  const handleUpgrade = () => {
    const currentPath = location.pathname + location.search;
    navigate(`${currentPath}${location.search ? '&' : '?'}upgrade=true`);
  };

  return (
    <>
      {userData !== null ? (
        <>
          <ShareContentModal
            isOpen={createShareContentIsOpen}
            onClose={onCloseShareContent}
            message={message}
            link={link}
            header={'Share Profile'}
            subject={'Hello! Check out this profile on SeedAFounder.'}
          />
          <UserReportModal
            isOpen={reportUserIsOpen}
            onClose={onCloseReportUser}
            user={userData}
          />
          <Box
            display="flex"
            cursor="pointer"
            onClick={onToggle}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box mr={2}>
              <HiOutlineArrowNarrowLeft size="20px" />
            </Box>
            <Box>
              <Text className="font-medium"> Go Back</Text>
            </Box>
          </Box>
          <VStack
            pb={2}
            overflow="hidden"
            overflowY="auto"
            w="100%"
            h="auto"
            bg="white"
            borderRadius="10px"
            boxShadow="0.5px 2px 10px lightgray"
          >
            <style>{` ::-webkit-scrollbar {display: none; }`}</style>
            <div className="bg-gray-300 w-full ">
              <div
                style={{
                  backgroundImage: `url(${data?.data?.user?.cover_image || founder_cover_photo})`,
                }}
                className="w-[100%] bg-no-repeat rounded-lg bg-cover bg-center h-60"
              ></div>
            </div>
            <Box className={`w-full`}>
              <div
                className={`flex w-full lg:w-[80%] max-w-[1000px]  mx-auto flex-wrap justify-between items-center px-5 py-5 lg:px-4`}
              >
                <Box className="flex flex-col items-center gap-3">
                  <Box borderRadius="50%">
                    <Avatar
                      name={`${userData?.first_name} ${userData?.last_name}`}
                      src={userData?.profile_image}
                      size={isDesktop ? '2xl' : 'xl'}
                    />
                  </Box>

                  <Flex className="flex-row gap-1 ml-1 items-center">
                    <StarIcon
                      h={3}
                      w={3}
                      color={userData?.rating > 0 ? 'yellow.400' : 'initial'}
                    />
                    <StarIcon
                      h={3}
                      w={3}
                      color={userData?.rating > 1 ? 'yellow.400' : 'initial'}
                    />
                    <StarIcon
                      h={3}
                      w={3}
                      color={userData?.rating > 2 ? 'yellow.400' : 'initial'}
                    />
                  </Flex>
                  <Box
                    className="items-center justify-center"
                    display="flex"
                    flexDir="column"
                    alignItems={!isDesktop ? 'flex-start' : 'center'}
                  >
                    <Text className="text-2xl font-semibold">
                      {`${userData?.first_name} ${userData?.last_name}`}
                    </Text>
                    {companyStatus && (
                      <Tooltip
                        label={getDealReadinessTooltip()}
                        hasArrow
                        placement="top"
                        isDisabled={!getDealReadinessTooltip()}
                      >
                        <Badge
                          mt={1}
                          colorScheme={isDealReady ? 'green' : 'orange'}
                          fontSize="xs"
                          px={2}
                          py={0.5}
                          borderRadius="full"
                        >
                          {isDealReady
                            ? 'Deal readiness: Ready'
                            : 'Deal readiness: In progress'}
                        </Badge>
                      </Tooltip>
                    )}
                  </Box>
                </Box>

                {source !== 'admin' && (
                  <div
                    className={`mb-5 flex flex-col gap-2 xs:mb-2 w-full mt-5 sm:mt-0 sm:max-w-[296px]`}
                  >
                    {userData?.id !== loggedInUserId && (
                      <ConnectionButton
                        style={{ backgroundColor: 'white' }}
                        user={userData}
                        onButtonClick={
                          isPublic ? handlePublicButtonClick : () => { }
                        }
                      />
                    )}

                    <Box
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isPublic) {
                          handlePublicButtonClick();
                        } else {
                          onOpenShareContent();
                        }
                      }}
                      className="flex gap-1 text-center text-sm p-2 w-full border cursor-pointer justify-center rounded hover:bg-green-100 items-center"
                    >
                      <FaShareAlt />
                      Share
                    </Box>

                    {userData?.id !== loggedInUserId && (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isPublic) {
                            handlePublicButtonClick();
                          } else {
                            onOpenReportUser();
                          }
                        }}
                        className="flex gap-1 text-center text-sm p-2 w-full border cursor-pointer justify-center rounded hover:bg-red-100 items-center"
                      >
                        <FaFlag />
                        Report Profile
                      </Box>
                    )}
                    <Box className="flex flex-col gap-2">
                      {deals && deals.length > 0 && (
                        <Box className="w-fit">
                          <BrandButton
                            fontSize="13px"
                            width="300px"
                            className="p-3"
                            isLoading={isLoading}
                            text={`${deals[0]?.termSheets?.length > 0 ? 'View' : 'Submit'} Termsheet`}
                            colorScheme="blue"
                            onClick={() => {
                              if (SUBSCRIPTION_FLAG == "on" && isFreeInvestor && deals[0]?.termSheets?.length === 0) {
                                handleUpgrade();
                              } else {
                                goToDeal(deals[0]?.id);
                              }
                            }}
                          />
                        </Box>
                      )}
                    </Box>
                  </div>
                )}

              </div>
            </Box>

            <Box className={`w-full p-5 xl:px-10 pb-20 bg-[#FAFAFA]`}>
              {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView && (
                <Box className={`w-full lg:w-[80%] max-w-[1000px] mx-auto mb-6`}>
                  <UpgradeBanner onUpgrade={handleUpgrade} isDesktop={isDesktop} />
                </Box>
              )}
              <Text className="text-lg font-medium text-[#2F4B6E] pb-10">
                Overview
              </Text>
              <Box
                className={`w-full lg:w-[80%] max-w-[1000px] mx-auto px-5 py-5 border rounded-lg lg:px-4`}
              >
                <Box className="flex flex-col xl:flex-row gap-8">
                  <Box className="flex flex-col gap-4 xl:w-[50%]">
                    <Text className="text-[#2F4B6E] text-lg font-medium">
                      Business Overview
                    </Text>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Company Name:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.title}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Location:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.incorporation_location
                            ?.map((item) => item?.name)
                            .join(', ')}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Social media:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.social_media_url ? (
                            <a
                              href={companyData.social_media_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:underline"
                            >
                              {companyData.social_media_url.length > 50
                                ? `${companyData.social_media_url.substring(0, 30)}...`
                                : companyData.social_media_url}
                            </a>
                          ) : (
                            '-'
                          )}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Website:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.website_url ? (
                            <a
                              href={companyData.website_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:underline"
                            >
                              {companyData.website_url.length > 50
                                ? `${companyData.website_url.substring(0, 30)}...`
                                : companyData.website_url}
                            </a>
                          ) : (
                            '-'
                          )}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Business model:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.business_model
                            ?.map((item) => item?.title)
                            .join(', ')}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Category:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.business_category
                            ?.map((item) => item?.title)
                            .join(', ')}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                  <Box className="flex flex-col gap-4 xl:w-[50%]">
                    <Text className="text-[#2F4B6E] text-lg font-medium">
                      Investment Overview
                    </Text>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Kind of investment:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.fund_category?.title}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Valuation:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.company_stage
                            ?.map((item) => item?.title)
                            .join(', ')}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Target Locations:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          {companyData?.investment_location
                            ?.map((item) => item?.name)
                            .join(', ')}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Equity offered:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          -
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Share price:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          -
                        </Text>
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Investors:
                      </Text>
                      <Box className="w-full">
                        <Text color="#000" className="font-medium">
                          -
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
              <Box className={`w-full lg:w-[80%] max-w-[1000px] mx-auto my-10`}>
                <Box>
                  {companyData.video_url &&
                    isValidURL(companyData.video_url) ? (
                    <object
                      data={ConvertVideoLinkToEmbedLink(companyData.video_url)}
                      width="100%"
                      className={`${isDesktop ? 'min-h-[400px]' : 'min-h-[200px]'} border rounded-lg`}
                    >
                      <iframe
                        width="100%"
                        height="50%"
                        src={ConvertVideoLinkToEmbedLink(companyData.video_url)}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </object>
                  ) : (
                    <Text color="text-gray-600 font-semibold p-3 text-center text-sm"></Text>
                  )}
                </Box>
              </Box>
            </Box>

            {deals?.length > 0 && (
              <Box className={`w-full p-5 xl:px-10 pb-20 bg-[#FAFAFA]`}>
                <Text className="text-lg font-medium text-[#2F4B6E] pb-5">
                  Deals
                </Text>

                <Box className="flex flex-col gap-2">
                  {deals?.map((item) => {
                    return (
                      <Box className="flex flex-col gap-2 w-fit p-4 border rounded-lg">
                        <Text className="text-lg font-semibold">
                          {item?.company?.title}
                        </Text>
                        <Box className="flex flex-col gap-1">
                          {item?.stage ? (
                            <Text>
                              <span className="font-medium">
                                Fundraising Round:
                              </span>{' '}
                              {item.stage}
                            </Text>
                          ) : null}
                          {item?.target_amount ? (
                            <Text>
                              <span className="font-medium">Raise Amount:</span>{' '}
                              ${item.target_amount.toLocaleString()}
                            </Text>
                          ) : null}
                          {item?.company?.valuation ? (
                            <Text>
                              <span className="font-medium">Valuation:</span> $
                              {item.company.valuation.toLocaleString()}
                            </Text>
                          ) : null}
                          {item?.stage_of_interaction ? (
                            <Text className="capitalize">
                              <span className="font-medium">
                                Stage of Interaction:
                              </span>{' '}
                              {item.stage_of_interaction.replace('_', ' ')}
                            </Text>
                          ) : null}
                          {item?.company?.funding_target ? (
                            <Text>
                              <span className="font-medium">
                                Funding Target:
                              </span>{' '}
                              $
                              {(
                                item?.company?.funding_target || '0'
                              ).toLocaleString()}
                            </Text>
                          ) : null}
                        </Box>
                        <Box className="w-fit mt-2">
                          <BrandButton
                            fontSize="13px"
                            bg="#20B962"
                            width="300px"
                            className="p-3"
                            isLoading={isLoading}
                            text={`${item?.termSheets?.length > 0 ? 'View' : 'Submit'} Termsheet`}
                            colorScheme="blue"
                            onClick={() => {
                              if (SUBSCRIPTION_FLAG == "on" && isFreeInvestor && item?.termSheets?.length === 0) {
                                handleUpgrade();
                              } else {
                                goToDeal(item.id);
                              }
                            }}
                          />
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
            {!isPublic && source != 'admin' && founder != loggedInUserId ? (
              <Box className={`w-full p-5 xl:px-10 pb-20 bg-[#FAFAFA]`}>
                <Box
                  h="100%"
                  mt={5}
                  className="w-full max-w-[700px] xl:max-w-[800px]"
                >
                  <Text
                    className="text-lg font-medium"
                    color="brand.primary"
                    my={4}
                  >
                    Booking Hours with {`${data?.data?.user?.first_name}`}
                  </Text>
                  <Box>
                    <Box>
                      <Box>
                        <Text fontWeight={500} color="#9FA7AD">
                          Select a Day
                        </Text>
                        <Text color="gray">
                          Select a suitable day to have your call from the
                          available days below.
                        </Text>
                        <Text className="text-gray-600 text-sm italic">
                          Dates highlighted in blue have available slots.
                        </Text>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minW="280px"
                        maxW="530px"
                        p={2}
                        m={2}
                      >
                        <FoundersBookingCalendar
                          refetch={refetchBookingsData}
                          founder={founder}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : null}

            <Box className={`w-full p-5 xl:px-10 pb-10 md:pb-20`}>
              <Text className="text-lg font-medium text-[#2F4B6E] pb-10">
                About Company
              </Text>
              <Box className={``}>
                <Box className="flex flex-col xl:flex-row gap-8">
                  <Box className="flex flex-col gap-4 xl:w-[50%]">
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Description:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.description}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.description}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Problem:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.problem}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.problem}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Solution:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.solution}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.solution}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Customer Type:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.customer_type}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.customer_type}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                  </Box>
                  <Box className="flex flex-col gap-4 xl:w-[50%]">
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Competition:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.competition}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.competition}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Use of Funds:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.fund_use}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.fund_use}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Stakeholders:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.stakeholders}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.stakeholders}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Market Growth:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.market_growth}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.market_growth}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex className="flex flex-wrap lg:flex-nowrap w-full gap-1 lg:min-h-[70px] xl:max-w-[500px] 2xl: max-w-[700px]">
                      <Text
                        className="w-[320px]"
                        fontWeight={500}
                        color="#C0BCBC"
                      >
                        Revenue Model:
                      </Text>
                      <Box className="w-full">
                        {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                          <LockedField
                            value={companyData?.revenue_model}
                            onUpgrade={handleUpgrade}
                            isDescription={true}
                            showUpgradeButton={false}
                          />
                        ) : (
                          <Text color="#000" className="font-medium">
                            {companyData?.revenue_model}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box w="100%" display="flex" alignItems="center" flexDir="column">
              {isDesktop ? (
                <Box w="80%" px={isDesktop ? 8 : 4} py={4}>
                  <Text
                    fontSize={isDesktop ? 20 : 16}
                    fontWeight={500}
                    color="brand.primary"
                  >
                    Pitch Deck
                  </Text>
                  {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                    <LockedField
                      value="Pitch deck is available with Starter or Pro plan. Upgrade to view the full document."
                      onUpgrade={handleUpgrade}
                      isDescription={true}
                    />
                  ) : pdfBlob ? (
                    <PitchDeckViewer pdfBlob={pdfBlob} />
                  ) : (
                    <Text className="text-gray-600 font-semibold p-3 text-center text-sm">
                      No pitch deck uploaded
                    </Text>
                  )}
                </Box>
              ) : (
                <Box py={4} w="100%">
                  {SUBSCRIPTION_FLAG == "on" && isFreeInvestor && restrictView ? (
                    <LockedField
                      value="Pitch deck is available with Starter or Pro plan. Upgrade to view the full document."
                      onUpgrade={handleUpgrade}
                      isDescription={true}
                    />
                  ) : pdfBlob ? (
                    <PitchDeckViewer pdfBlob={pdfBlob} />
                  ) : (
                    <Text className="text-gray-600 font-semibold p-3 text-center text-sm">
                      No pitch deck uploaded
                    </Text>
                  )}
                </Box>
              )}
            </Box>
          </VStack>
        </>
      ) : (
        <Box>
          <Spinner />
        </Box>
      )}
    </>
  );
};
export default ViewFounderDetails;
